export { CorporationPage as default } from '@/components/enpages/Contact/Corporation/index'
